<template>
  <div>
    <h3 class="text-xl text-gray-800 mt-8 mb-4 font-bold">Accordion - FAQ</h3>
    <AccordionModal :accordions="faq" class="w-4/12" />
  </div>
  <div>
    <h3 class="text-xl text-gray-800 mt-8 mb-4 font-bold">Modal</h3>
    <Modal class="w-4/12" />
    <span class="ml-8 w-30"></span>
  </div>
</template>

<script>
import AccordionModal from "@/Components/UI/Modals/Accordion.vue";
import Modal from "@/Components/UI/Modals/Modal.vue";

export default {
  components: { AccordionModal, Modal },
  data() {
    return {
      accordion: "Accordion",

      faq: [
        {
          title: "Pergunta de uma linha",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Tenetur, architecto, explicabo perferendis nostrum, maxime impedit atque odit sunt pariatur illo obcaecati soluta molestias iure facere dolorum adipisci eum? Saepe, itaque.",
          opened: true,
        },
        {
          title: "Pergunta de uma linha - 2",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Tenetur, architecto, explicabo perferendis nostrum, maxime impedit atque odit sunt pariatur illo obcaecati soluta molestias iure facere dolorum adipisci eum? Saepe, itaque.",
          opened: false,
        },
        {
          title: "Pergunta de uma linha - 3",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Tenetur, architecto, explicabo perferendis nostrum, maxime impedit atque odit sunt pariatur illo obcaecati soluta molestias iure facere dolorum adipisci eum? Saepe, itaque.",
          opened: false,
        },
      ],
    };
  },
};
</script>
